const DB_NAME = "avatarsDB";
const STORE_NAME = "avatars";

function openDatabase() {
	return new Promise((resolve, reject) => {
		const request = indexedDB.open(DB_NAME, 1);

		request.onupgradeneeded = (event) => {
			const db = event.target.result;
			if (!db.objectStoreNames.contains(STORE_NAME)) {
				db.createObjectStore(STORE_NAME, { keyPath: "userId" });
			}
		};

		request.onsuccess = (event) => {
			resolve(event.target.result);
		};

		request.onerror = () => {
			reject(request.error);
		};
	});
}

export function getCachedAvatar(userId) {
	return new Promise((resolve) => {
		if (!userId) {
			resolve(null);
			return;
		}

		openDatabase()
			.then((db) => {
				const transaction = db.transaction([STORE_NAME], "readonly");
				const store = transaction.objectStore(STORE_NAME);
				const request = store.get(userId);

				request.onsuccess = () => {
					resolve(request.result ? request.result.img : null);
				};

				request.onerror = () => {
					resolve(null);
				};
			})
			.catch(() => {
				resolve(null);
			});
	});
}

export function saveCachedAvatar(userId, img) {
	return new Promise((resolve) => {
		if (!userId || img === undefined) {
			resolve();
			return;
		}

		openDatabase()
			.then((db) => {
				const transaction = db.transaction([STORE_NAME], "readwrite");
				const store = transaction.objectStore(STORE_NAME);
				const request = store.put({ userId, img });

				request.onsuccess = () => resolve();
				request.onerror = () => resolve();
			})
			.catch(() => {
				resolve();
			});
	});
}
